'use strict';

angular.module('route')
    .provider('Route', function() {
        var securedRoutes = [];

        this.create = function(name, options) {
            // Store state name
            options.name = name;

            // Is secured
            var secure = typeof options.secure === 'undefined' ? true : !!options.secure;
            if (secure) {
                securedRoutes.push(options.name);
            }

            // Route resolvers
            options.resolve = options.resolve || {};

            // Get logged user
            options.resolve.loggedUser = ['RouteAuth', function(RouteAuth) {
                return RouteAuth.init()
                    .then(function() {
                        return RouteAuth.getLoggedUser();
                    });
            }];

            // Redirection depending on logged user
            var redirecIfLogged = null;
            var redirecIfNotLogged = null;

            if (options.redirectIf) {
                redirecIfLogged = options.redirectIf.logged || null;
                redirecIfNotLogged = options.redirectIf.notLogged || null;

                options.redirectTo = function(transition, state) {
                    var loggedUserPromise = transition.injector().getAsync('loggedUser');

                    return loggedUserPromise.then(function(loggedUser) {
                        if (loggedUser.id) {
                            return redirecIfLogged;
                        } else {
                            return redirecIfNotLogged;
                        }
                    });
                };
            }

            // If route is secure and is not defined any redirection if user is not logged >> Error
            if (secure && (!options.redirectIf || !options.redirectIf.notLogged)) {
                options.resolve.checkUserIsLogged = ['$q', 'RouteAuth', 'loggedUser', 'RouteError', function($q, RouteAuth, loggedUser, RouteError) {
                    if (!RouteAuth.isLogged()) {
                        var error = new RouteError('authentication-required');

                        return $q.reject(error);
                    }
                }];
            }

            // Check user permission
            if (options.permission) {
                options.resolve.checkPermission = ['$q', 'RouteAuth', 'loggedUser', 'RouteError', function($q, RouteAuth, loggedUser, RouteError) {
                    if (!RouteAuth.hasPermission(options.permission)) {
                        var error = new RouteError('permission-required');

                        return $q.reject(error);
                    }
                }];
            }

            return options;
        };

        this.$get = ['$state', function($state) {
            return {
                isSecure: function(routeName) {
                    if (!routeName) {
                        routeName = $state.current.name;
                    }

                    return securedRoutes.indexOf(routeName) !== -1;
                },
            };
        }];
    });
